// extracted by mini-css-extract-plugin
export default {"table__image-size":"table__image-size_lC38JxKr"};